import { endOfDay } from "date-fns/endOfDay";
import { startOfDay } from "date-fns/startOfDay";
import { config } from "~initializer/config.ts";

export function isInventoryPeriod() {
  const {
    inventoryStartMonth,
    inventoryStartDay,
    inventoryEndMonth,
    inventoryEndDay,
  } = config();
  const date = new Date();
  const year = date.getFullYear();
  const previousYearPeriodEnd = endOfDay(
    new Date(year, inventoryEndMonth - 1, inventoryEndDay),
  );
  const currentYearPeriodStart = startOfDay(
    new Date(year, inventoryStartMonth - 1, inventoryStartDay),
  );
  return date >= currentYearPeriodStart || date <= previousYearPeriodEnd;
}
